/**
 * 카메라 관련 유틸리티 함수
 * - base64 → File 변환
 * - 파일명 생성
 */

/**
 * base64 문자열을 File 객체로 변환
 * @param base64 - base64 인코딩된 이미지 데이터 (data URI prefix 없는 순수 base64)
 * @param fileName - 생성할 파일명
 * @param mimeType - MIME 타입 (기본: image/jpeg)
 */
export function base64ToFile(base64: string, fileName: string, mimeType = "image/jpeg"): File {
  const byteString = atob(base64);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new File([ab], fileName, { type: mimeType });
}

/**
 * 촬영 사진 파일명 생성
 * 형식: photo_1234567890123.jpg
 */
export function generatePhotoFileName(): string {
  return `photo_${Date.now()}.jpg`;
}
